<template>
  <div class="orderMessage full-height">
    <ld-header>
      消息
    </ld-header>
    <van-tabs
      v-model="active"
      @change="getList"
    >
      <van-tab
        v-for="(item,index) in menuList"
        :key="index"
        :title="item.title"
        :name="item.cplx"
      >
        <div class="orderMessagewrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
            @init="mescrollInit"
          >
            <div class="list">
              <div
                v-for="el in list"
                :key="el.msgType"
                class="list"
                @click="toOrderDetail(el)"
              >
                <van-cell style="border-top-left-radius:10px;border-top-right-radius:10px;">
                  <van-row>
                    <van-col
                      span="12"
                      class="van-ellipsis"
                    >
                      <svg
                        class="svg-icon font22"
                        aria-hidden="true"
                      >
                        <use :xlink:href="el.orderType|icon" />
                      </svg>&nbsp;
                      <span class="font16">{{ el.tzTitle }}</span>
                    </van-col>
                    <van-col
                      span="12"
                      class="text-right gray"
                    >
                      {{ el.savedate }}
                    </van-col>
                  </van-row>
                </van-cell>
                <van-cell>
                  <div class="deep-gray van-multi-ellipsis--l2">
                    {{ el.ydContent }}
                  </div>
                </van-cell>
                <van-cell style="border-bottom-left-radius:10px;border-bottom-right-radius:10px;">
                  <van-row
                    class="deep-gray"
                  >
                    <van-col span="18">
                      订单号：{{ el.orderNo }}
                    </van-col>
                    <van-col
                      span="6"
                      class="text-right"
                    >
                      查看详情
                    </van-col>
                  </van-row>
                </van-cell>
              </div>

              <van-empty v-if="list.length === 0" />
              <ld-no-more v-if="list.length === 0" />
            </div>
          </mescroll-vue>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Grid, GridItem, Icon, NoticeBar ,Cell,Image as VanImage,Tab, Tabs, Empty } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import Bussiness from 'Utils/business'
import ldNoMore from 'Common/ldNoMore'

import approval from 'Components/Dynamic/btlh/images/message/approval.png'
import advice from 'Components/Dynamic/btlh/images/message/advice.png'
import message from 'Components/Dynamic/btlh/images/message/message.png'
import pay from 'Components/Dynamic/btlh/images/message/pay.png'
import order from 'Components/Dynamic/btlh/images/message/order.png'
import kf from 'Components/Dynamic/btlh/images/message/kf.png'


export default {
  name: 'Message',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [VanImage.name]: VanImage,
    [Empty.name]: Empty,
    ldNoMore,
    MescrollVue,
  },
  data () {
    return {
      active:'',
      down:{ use: false },
      kfShow: false,
      kf,
      menuList: [
        {
          link: '/tk/tkQuery',
          title: '全部',
          cplx:'',
          img: order
        },
        {
          link: '/tk/tkQuery',
          title: '机票',
          cplx:'10901',
          img: order
        },
        {
          link: '/ht/htQuery',
          title: '酒店',
          cplx:'10903',
          img: approval
        },
        {
          link: '/car/carQuery',
          title: '火车',
          cplx:'10904',
          img: message
        },
        {
          link: '/tr/trQuery',
          title: '用车',
          cplx:'10906',
          img: pay
        },
      ],
      list:[]
    }
  },
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices'])
  },
  created () {
    this.getLoginNotice(0)
    this.getList()
  },
  mounted () {
  },
  methods:{
    ...mapActions(['getLoginNotice']),
    // 获取消息列表
    mescrollInit (mescroll) {
      this.mescroll = mescroll
    },
    getList(){
      //1系统消息、2订单通知、3审批信息、4航变信息、5企业通知 
      this.$api['common/findGgtzByMsgType']({
        'msgType': 2,
        'productType': this.active
      }).then(res=>{
        var data = res.data ? res.data.list ? res.data.list : [] : []
        this.list = data

        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess()
        })
      })
    },
    //去订单详情
    toOrderDetail (el) {
      Bussiness.toOrderDetail({id:el.orderId,orderType:el.orderType})
    },
  },
  filters:{
    icon(val){
      var obj={
        11001:'#iconweibiaoti-133',
        11002:'#iconweibiaoti-133',
        11003:'#iconweibiaoti-133',
        11004:'#iconweibiaoti-133',
        11005:'#iconweibiaoti-133',
        11006:'#iconweibiaoti-133',

        11007:'#iconweibiaoti-134',
        11008:'#iconweibiaoti-134',

        11009:'#iconweibiaoti-135',
        11010:'#iconweibiaoti-135',
        11011:'#iconweibiaoti-135',

        11018:'#iconweibiaoti-136',
      }
      return obj[val] || ''
    }
  }
}
</script>

<style lang="less" scoped>
    .orderMessagewrapper{
        height: calc(100vh - 90px);
        overflow: hidden;
    }
    .home-banner {
        background-image: url('~Components/Dynamic/btlh/images/bg.png');
    }
    .list{
        padding: 5px;
    }
</style>
